import { useSelector } from "react-redux";
import CardContainer from "./Common/CardContainer";

/**
 *
 * @param {*} props
 * title
 * nullCheckMsg
 *
 */

const Wishlist = (props) => {
  var title, nullCheckMsg, cardContainerData;
  if (props?.data) {
    ({ title, nullCheckMsg } = props.data);
  }
  const products = useSelector((state) => state.product.products);
  var wishlistItems = products?.filter((prod) => prod.inWishlist);
  wishlistItems = wishlistItems.map((itm) => {
    return { id: itm.id };
  });
  if (title && nullCheckMsg && wishlistItems?.length === 0) {
    cardContainerData = [
      {
        title,
        componentContent: nullCheckMsg,
      },
    ];
  } else {
    cardContainerData = [
      {
        title,
        catalogCard: wishlistItems,
      },
    ];
  }

  return <CardContainer data={cardContainerData} />;
};

export default Wishlist;
